export default "__VITE_ASSET__DYHfEo6A__"